const windowWidth = window.innerWidth;

const ajaxurl = msftv.ajax_url;

/*
 * Template Medias
 */
const popup = document.querySelector('.js-popup');

// Main slider
let swiper = new Swiper('.swiper-medias', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 80,
    watchSlidesProgress: true,
    freeMode: true
});

const slides = document.querySelectorAll('.js-slide');
slides.forEach(slide => {
    let btn = slide.querySelector('.js-open');
    btn.addEventListener('click', () => {
        const isExpanded = slide.classList.contains('--expanded');
        slides.forEach((slide) => {
            slide.classList.remove('--expanded');
            console.log(slide.querySelector('.js-open-btn'))
            slide.querySelector('.js-open-btn').classList.remove('--close');
        });

        if (!isExpanded) {
            slide.classList.add('--expanded');
            slide.querySelector('.js-open-btn').classList.add('--close');
        }

        setTimeout(function () {
            swiper.update();
            swiper.translateTo(-(swiper.clickedIndex * 1040), 600);
        }, 600);
    });
})

// Open mission
const btnsPlay = document.querySelectorAll('.js-play');
btnsPlay.forEach(btnPlay => {
    btnPlay.addEventListener('click', () => {
        let data = {};
        const type = btnPlay.dataset.type
        let src = btnPlay.dataset.src

        if (type == 'video') {
            data = {
                action: 'get_video',
                url: src
            }
        } else {
            images = JSON.parse(src);

            data = {
                action: 'get_slideshow',
                images: images
            }
        }

        fetch(ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: new URLSearchParams(data),
        })
        .then(response => response.json())
        .then(response => {
            if(!response.success) {
                console.log(response.data);
                return;
            }

            popup.innerHTML = response.data;
            if (type == 'video') {
                initVideo(popup);
            } else {
                initSlideshow(popup);
            }

            popup.classList.add('--open');

            const closePopupBtn = popup.querySelector('.js-close');
            closePopupBtn.addEventListener('click', function () {
                closePopup(popup);

                if (popup.querySelector('video')) {
                    let videoPlayer = popup.querySelector('video');
                    videoPlayer.pause(); 
                    videoPlayer.currentTime = 0;
                }
            });

            const popupNav = popup.querySelector('.js-popup-nav');
            popup.addEventListener('click', (e) => {
                popupNav.classList.toggle('--hide');
            });
        });
    });
});

function initSlideshow (thePopup) {
    let slideshow = new Swiper('.swiper-slideshow', {
        direction: 'horizontal',
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        disableOnInteraction: false,
        effect: 'fade',
        autoplay: {
            delay: 6000,
        },
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        }
    });

    thePopup.querySelector('.swiper-button-prev').addEventListener('click', (e) => {
        e.stopPropagation();
    });
    thePopup.querySelector('.swiper-button-next').addEventListener('click', (e) => {
        e.stopPropagation();
    });
}

function closePopup (thePopup) {
    thePopup.classList.remove('--open');
    thePopup.innerHTML = '';
}

/*
 * Template Home
 */
// Video popup
const homeBtnVideo = document.querySelector('.js-home-open-video');
const homePopupVideo = document.querySelector('.js-homepopup-video');
initVideo(homePopupVideo, false);
homeBtnVideo.addEventListener('click', () => {
    let videoPlayer = homePopupVideo.querySelector('video');

    videoPlayer.play();

    homePopupVideo.classList.add('--open');
});

// Keypoint fit
textFit(document.querySelector('.js-fit-keypoint'), {maxFontSize: 310, alignVert: true});

// Keypoint popup
const homeBtnKeypoint = document.querySelector('.js-home-open-keypoint');
const homePopupKeypoint = document.querySelector('.js-homepopup-keypoint');
if (homeBtnKeypoint) {
    homeBtnKeypoint.addEventListener('click', () => {
        homePopupKeypoint.classList.add('--open');
    });
}

// Donators popup
const homeBtnDonators = document.querySelector('.js-home-open-donators');
const homePopupDonators = document.querySelector('.js-homepopup-donators');
homeBtnDonators.addEventListener('click', () => {
    homePopupDonators.classList.add('--open');
});

// Slideshow popup
const homeBtnSlideshow = document.querySelector('.js-home-open-slideshow');
const homePopupSlideshow = document.querySelector('.js-homepopup-slideshow');
initSlideshow(homePopupSlideshow);
homeBtnSlideshow.addEventListener('click', () => {
    homePopupSlideshow.classList.add('--open');
});

// Close
const homeBtnsClose = document.querySelectorAll('.js-close-homepopup');
homeBtnsClose.forEach(homeBtnClose => {
    homeBtnClose.addEventListener('click', () => {
        const homepopup = homeBtnClose.closest('.homepopup-content');
        homepopup.classList.remove('--open');

        if (homepopup.classList.contains('js-homepopup-video')) {
            let videoPlayer = homepopup.querySelector('video');
            videoPlayer.pause(); 
            videoPlayer.currentTime = 0;
        }
    });
});

// Video
function initVideo (thePopup, autoplay = true) {
    let videoPlayer = thePopup.querySelector('video');
    let playerBtn = thePopup.querySelector('.js-playpause');
    let seekslider = thePopup.querySelector('.js-seekslider');

    videoPlayer.addEventListener('loadedmetadata', function () {
        initializeVideo(thePopup);
    });
    videoPlayer.addEventListener('timeupdate', function () {
        updateProgress(thePopup);
    });
    videoPlayer.addEventListener('timeupdate', function () {
        updateTimeElapsed(thePopup);
    });
    videoPlayer.addEventListener('ended', function () {
        closePopup(thePopup);
    });
    seekslider.addEventListener('input', function (e) {
        skipAhead(e, thePopup);
    });

    if (autoplay) {
        videoPlayer.play();
    }

    playerBtn.addEventListener('click', (e) => {
        e.stopPropagation();

        if (videoPlayer.paused || videoPlayer.ended) {
            playerBtn.setAttribute('data-state', 'play');
            videoPlayer.play();
        } else {
            playerBtn.setAttribute('data-state', 'pause');
            videoPlayer.pause();
        }
    });
}

function initializeVideo(thePopup) {
    let videoPlayer = thePopup.querySelector('video');
    let progressBar = thePopup.querySelector('.js-progress-bar');
    let seekslider = thePopup.querySelector('.js-seekslider');
	let duration = thePopup.querySelector('.js-duration');

    const videoDuration = Math.round(videoPlayer.duration);
    seekslider.setAttribute('max', videoDuration);
    progressBar.setAttribute('max', videoDuration);

    const time = formatTime(videoDuration);
    duration.innerText = `${time.minutes}:${time.seconds}`;
    duration.setAttribute('datetime', `${time.minutes}m ${time.seconds}s`)
}

function formatTime(timeInSeconds) {
    const result = new Date(timeInSeconds * 1000).toISOString().substr(11, 8);
  
    return {
      minutes: result.substr(3, 2),
      seconds: result.substr(6, 2),
    };
};

function updateProgress(thePopup) {
    let videoPlayer = thePopup.querySelector('video');
    let progressBar = thePopup.querySelector('.js-progress-bar');
    let seekslider = thePopup.querySelector('.js-seekslider');

    seekslider.value = Math.floor(videoPlayer.currentTime);
    progressBar.value = Math.floor(videoPlayer.currentTime);
}

function skipAhead(event, thePopup) {
    let videoPlayer = thePopup.querySelector('video');
    let progressBar = thePopup.querySelector('.js-progress-bar');
    let seekslider = thePopup.querySelector('.js-seekslider');

    const skipTo = event.target.dataset.seek ? event.target.dataset.seek : event.target.value;
    videoPlayer.currentTime = skipTo;
    progressBar.value = skipTo;
    seekslider.value = skipTo;
}

function updateTimeElapsed(thePopup) {
    let videoPlayer = thePopup.querySelector('video');
    let timeElapsed = thePopup.querySelector('.js-curr-time');

    const time = formatTime(Math.round(videoPlayer.currentTime));

    timeElapsed.innerText = `${time.minutes}:${time.seconds}`;
    timeElapsed.setAttribute('datetime', `${time.minutes}m ${time.seconds}s`)
}
